import { InsertDriveFile } from '@mui/icons-material'
import styled from 'styled-components'

import { IconStyles } from '../types'

export const SeeFileCustom = styled(InsertDriveFile)<IconStyles>``
